var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadArrowSlim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4390_52347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3535 12.3535L19.6465 11.6465L12.5 18.793V0H11.5V18.793L4.3535 11.6465L3.6465 12.3535L12 20.707L20.3535 12.3535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 17.5V20C23 21.6545 21.6545 23 20 23H4C2.3455 23 1 21.6545 1 20V17.5H0V20C0 22.2055 1.7945 24 4 24H20C22.2055 24 24 22.2055 24 20V17.5H23Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4390_52347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadArrowSlim);
export default __webpack_public_path__ + "static/media/download_arrow_slim.5e0adc5698e519c3caa97b089efb93f4.svg";
export { ForwardRef as ReactComponent };